// extracted by mini-css-extract-plugin
module.exports = {"poweredBy":"styles_poweredBy__2WTD0","logo":"styles_logo__2e0Hw","mobileLogo":"styles_mobileLogo__EStFe styles_logo__2e0Hw"};